import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
// *******************toster****************************
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";
import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import classNames from "classnames";
library.add(fas);

const EditOffCanvance = (props) => {
  const id = props.show;
  const { postData, getData } = useContext(Context);
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const GetEditData = async () => {
    const response = await getData(`/masters/local-packages/${id}`);
    reset(response?.data);
  };
  useEffect(() => {
    GetEditData();
  }, []);

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  const onSubmit = async (data) => {
    try {
      console.log(data);
      const response = await postData(`/masters/local-packages/${id}`, data);
      console.log(response);
      if (response?.success) {
        await setShowModal({ code: response.code, message: response.message });
      } else {
        await setShowModal({ code: response.code, message: response.message });
      }
      setTimeout(() => {
        setShowModal(0);
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <Modal
        {...props}
        onHide={props.handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="edit-modal-holder"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Edit Local Packages
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={() => handleSubmit(onSubmit)} role="form">
            <Row className="justify-content-center">

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <div className="">
                      <Form.Label>Hour</Form.Label>
                    </div>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="hour"
                        placeholder="Hour"
                        className={classNames("", {
                          "is-invalid": errors?.hour,
                        })}
                        {...register("hour", {
                          required: "hour is required",
                        })}
                        onKeyDown={(e) => {
                          if (
                            e.key === '+' || // Prevent plus sign
                            e.key === 'e' || // Prevent scientific notation
                            e.key === 'E' || // Prevent scientific notation
                            (isNaN(Number(e.key)) &&
                              e.key !== 'Backspace' &&
                              e.key !== 'Tab' &&
                              e.key !== '.' // Allow decimal point
                            ) ||
                            (e.key === '.' && e.target.value.includes('.')) // Prevent multiple decimal points
                          ) {
                            e.preventDefault();
                          }
                        }}
                        onPaste={(e) => {
                          const pasteData = e.clipboardData.getData('text');
                          if (!/^\d*\.?\d*$/.test(pasteData)) { // Allow only numbers with optional single decimal
                            e.preventDefault();
                          }
                        }}

                      />
                    </InputGroup>
                    {errors.hour && (
                      <span className="text-danger">{errors.hour.message}</span>
                    )}
                  </Form.Group>
                </div>
              </Col>
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <div className="">
                      <Form.Label>Kilometer</Form.Label>
                    </div>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="kilometer"
                        placeholder="Kilometer"
                        className={classNames("", {
                          "is-invalid": errors?.kilometer,
                        })}
                        {...register("kilometer", {
                          required: "kilometer is required",
                        })}
                        onKeyDown={(e) => {
                          if (
                            e.key === '+' || // Prevent plus sign
                            e.key === 'e' || // Prevent scientific notation
                            e.key === 'E' || // Prevent scientific notation
                            (isNaN(Number(e.key)) &&
                              e.key !== 'Backspace' &&
                              e.key !== 'Tab' &&
                              e.key !== '.' // Allow decimal point
                            ) ||
                            (e.key === '.' && e.target.value.includes('.')) // Prevent multiple decimal points
                          ) {
                            e.preventDefault();
                          }
                        }}
                        onPaste={(e) => {
                          const pasteData = e.clipboardData.getData('text');
                          if (!/^\d*\.?\d*$/.test(pasteData)) { // Allow only numbers with optional single decimal
                            e.preventDefault();
                          }
                        }}

                      />
                    </InputGroup>
                    {errors.kilometer && (
                      <span className="text-danger">{errors.kilometer.message}</span>
                    )}
                  </Form.Group>
                </div>
              </Col>

              <Row className="mt-5 pb-3">
                <div className="d-flex justify-content-center">
                  <Link>
                    <CancelButton
                      name={"cancel"}
                      handleClose={props.handleClose}
                    />
                  </Link>

                  <SaveButton
                    name={"save"}
                    handleSubmit={handleSubmit(onSubmit)}
                  />
                </div>
              </Row>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default EditOffCanvance;
